import { StateCreator } from "zustand";
import { ActiveOfficeByDriverPass, QueueRecord } from "./api";

export interface QueueSlice {
  carNumber: string;
  queueRecord: QueueRecord | null;
  driverPassOffices: ActiveOfficeByDriverPass[];
  setCarNumber: (value: string) => void;
  setQueueRecord: (record: QueueRecord | null) => void;
  setDriverPassOffices: (offices: ActiveOfficeByDriverPass[]) => void;
}

export const createQueueSlice: StateCreator<QueueSlice> = set => ({
  carNumber: "",
  queueRecord: null,
  driverPassOffices: [],
  setCarNumber: carNumber => set({ carNumber }),
  setQueueRecord: queueRecord => set({ queueRecord }),
  setDriverPassOffices: driverPassOffices => set({ driverPassOffices }),
});
